export default __webpack_public_path__ + "static/analysis-5922b89a61fa1d2ff8b55e5568911ce6.png";